<template>
  <div class="remind">
    <div class="remind__top">
       <span class="remind__title">
        RESET HASŁA
      </span>
      <span class="remind__close" @click="closeModal"/>
    </div>
    <div class="remind__form">
      <LoginModalInput type="email" placeholder="E-mail" action/>


    </div>
            <div class="remind__buttons">

    <SelectButton buttonName="Zresetuj" :action="this.remind"/>
    <button class="remind__cancel" @click="closeModal">anuluj</button>
            </div>
  </div>
</template>

<script>
import SelectButton from '@/ui/SelectButton.vue';
import LoginModalInput from "@/ui/LoginModalInput.vue";
import mixin from '../mixin';

export default {
  mixins: [mixin],
  components: {
    SelectButton,
    LoginModalInput
  }
};
</script>

<style scoped lang="scss">
.remind {
  width: 94%;
  background-color: #ffffff;
  border-radius: 5px;
  display: flex;
  flex-direction: column;
  align-items: center;
  
  &___buttons {
    width: 28%;
  }

  &__top {
    height: 3rem;
    width: 100%;
    background-image: linear-gradient(to right, #df2860, #af2f82);
    position: relative;
    border-top-left-radius: 5px;
    border-top-right-radius: 5px;
 display: flex;
    align-items: center;

  }
  &__title {
    font-family: 'Poppins';
    color: white;
    margin-left: 1rem;

  }
  &__form {
    width: 66%;
    display: flex;
    flex-direction: column;
    margin-top: 2.5rem;
  }
  &__close {
    color: #fff;
    font-size: 30px;
    position: absolute;
    top: 1rem;
    right: 1rem;
    cursor: pointer;

    width: 1.25rem;
    height: 1.25rem;
    display: block;
    background-image: url("~@/assets/loginModal__close.png");
    background-size: cover;
    background-position: center;
  }
  &__label {
    visibility: hidden;
  }
  &__input {
    width: 100%;
    height: 2.875rem;
    border: none;
    border-radius: 5px;
    background-color: #d0d0e0;
    margin-bottom: 0.875rem;
    padding-left: 17%;
    font-family: "Poppins", sans-serif;
    color: #2c253f;
    box-sizing: border-box;
  }
  &__flex {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 66%;
    font-family: "Poppins", sans-serif;
    color: #5e5a6b;
    font-style: italic;
  }
  .flex {
    &__checkbox {
      margin: 0;

      &:hover {
        cursor: pointer;
      }
    }
    &__remember {
      display: flex;
      align-items: center;
      font-size: 11px;
    }
    &__forgot {
      font-size: 11px;
      &:hover {
        text-decoration: underline;
        cursor: pointer;
      }
    }
    &__label {
      margin-left: 0.5rem;
      &:hover {
        cursor: pointer;
      }
    }
  }

  &__cancel {
    width: 100%;
    height: 2.5rem;
    font-size: 1rem;
    text-transform: uppercase;
    border: none;
    border-radius: 5px;
    color: #0f1626;
    letter-spacing: 0.8px;
    margin-bottom: 1rem;
    background-color: transparent;
    cursor: pointer;
    &:hover {
      background-color: darken(#fff, 10%);
    }
  }
}
</style>
